import { TemplateVideoPlayerWithRatioListPositions, TemplateVideoPlayerWrapperHeights } from '../TemplateVideoPlayer';
import { VideoRatioItemProps } from '../VideoRatioList';

export type TemplateVideoWithControlsOrientations = 'vertical' | 'horizontal' | 'horizontal_with_slider';

export const TemplateVideoPlayerWithRatioListMap: {
  [key in TemplateVideoWithControlsOrientations]: TemplateVideoPlayerWithRatioListPositions;
} = {
  vertical: 'bottom_buttons',
  horizontal: 'top_buttons',
  horizontal_with_slider: 'top_buttons'
};

export const TemplateVideoPlayerWrapperHeightsMap: {
  [key in TemplateVideoWithControlsOrientations]: TemplateVideoPlayerWrapperHeights;
} = {
  vertical: 'video_dependence',
  horizontal: 'screen_dependence',
  horizontal_with_slider: 'screen_dependence_with_slider'
};

export type VideoTypeProps = {
  isVideoVertical: boolean;
};

export type EditButtonProps = {
  isSingleButton?: boolean;
  currentRatioFormat?: VideoRatioItemProps;
  onMobileEdit?(): void;
  onTemplateEdit?(): void;
};
